// 德语
export default {
  customProduct: {
    CustomProduct: 'Custom Product',
    Status: 'Status',
    SampleFee: 'Sample Fee',
    inputPlaceholder: 'Suche nach Produktnamen oder Anforderungsnummer.',
    AddNewDemand: 'Add New Demand',
    Product: 'Produkt',
    AddedTime: 'Added Time',
    DemandStatus: 'Nachfragestatus',
    PaymentStatus: 'Zahlungsstatus',
    Action: 'Aktion',
    Details: 'Details',
    DemandNo: 'NachfrageNr',
    More: 'Mehr',
    Edit: 'Bearbeiten',
    PaySampleFee: 'Pay Sample Fee',
    PaymentRecords: 'Payment Records',
    Cancel: 'Abbrechen',
    Unreceived: 'Nicht empfangen',
    Received: 'Empfangen',
    Completed: 'Abgeschlossen',
    Canceled: 'Storniert',
    Published: 'Veröffentlicht',
    Unpaid: 'unbezahlt',
    Paid: 'Bezahlt',
    CreatedTime: 'Erstellungszeit',
    TransactionTime: 'Transaktionszeit',
    Amount: 'Betrag',
    PaySampleFeeTips: 'Bitte zahlen Sie die Beispielgebühr, Beispielauftrag kann nach Zahlung generiert werden',
    PaymentAmount: 'Zahlungsbetrag',
    PaymentMethod: 'Zahlungsmethode',
    CreditCard: 'Kreditkarte',
    Balance: 'Saldo',
    Confirm: 'Bestätigen',
    transactionError: 'Ausnahme für Transaktionsaufträge generieren',
    CustomProcess: 'Benutzerdefinierter Prozess',
    stepTitle1: 'Senden Sie Ihre individuellen Anforderungen',
    stepDescription1_1: 'Klicken Sie auf die',
    stepDescription1_2: 'Geben Sie die Informationen der Produkte ein, die Sie anpassen müssen.',
    stepTitle2: 'Nehmen Sie Kontakt mit unserem Kundenservice auf',
    stepDescription2: 'Unser Kundendienstmitarbeiter wird Ihnen eine Kontakt-E-Mail senden, um Ihre individuellen Anforderungen mit Ihnen zu kommunizieren.',
    stepTitle3: 'Zahlung und Lieferung von Mustern',
    stepDescription3: 'Der Kunde zahlt die Proofing-Gebühr und Kakaclo schickt die Probe an den Kunden zur Bestätigung.',
    stepTitle4: 'Bestätigung der Muster und formale Produktion',
    stepDescription4: 'Sobald die Probe bestätigt ist, können Sie unseren Kundendienst-Vertreter kontaktieren, um die formale Produktion zu beginnen.'
  },
  customDetail: {
    Back: 'Zurück',
    AddNewDemand: 'Neue Nachfrage hinzufügen',
    Style: 'Stil',
    ProductName: 'Produktname',
    ProductNamePlace: 'T-Shirt, Rock, Jacke usw.',
    ContactEmail: 'Kontakt E-Mail',
    ContactEmailPlace: 'Geben Sie eine gültige E-Mail-Nummer ein',
    PhoneNumber: 'Telefonnummer',
    EstimatedOrderQuantity: 'Geschätzte Bestellmenge',
    EstimatedOrderQuantityPlace: 'Anzahl der bestellten Produkte',
    ColorQuantity: 'Farbmenge',
    ColorQuantityPlace: 'Wie viele Farben möchten Sie anpassen?',
    SizeQuantity: 'Größe Menge(pro Farbe)',
    SizeQuantityPlace: 'Wie viele Größen möchten Sie anpassen?',
    ReferenceLinking: 'Referenzverknüpfung',
    ReferenceLinkingTooltip: 'Der Link des Produkts, das Sie anpassen möchten.',
    ReferenceLinkingPlace: 'Geben Sie die Link-Adresse ein',
    Description: 'Beschreibung',
    DescriptionPlace: 'Teilen Sie uns die Details des Produkts mit, das Sie anpassen möchten.',
    Image: 'Bild',
    ImageTip: '(Bild darf nur bis zu 10 betragen.)',
    Fabric: 'Gewebe',
    Category: 'Kategorie',
    FabricName: 'Stoffname',
    CategoryPlace: 'Leinen, Baumwolle usw.',
    Weight: 'Gewicht(g)',
    WeightPlace: 'Das Gewicht des Stoffes',
    Composition: 'Zusammensetzung',
    Add: 'Hinzufügen',
    Accessories: 'Zubehör',
    Printing: 'Drucken',
    PrintingType: 'Druckart',
    PrintingTypePlace: 'Pigmentdruck usw.',
    ReferenceLinkingPlace2: 'Der Bezugslink des Musters',
    Width: 'Breite(cm)',
    WidthPlace: 'Die Breite des Patten',
    Length: 'Länge(cm)',
    LengthPlace: 'Die Länge des Patten',
    Position: 'Position',
    PositionPlace: 'Die Druckposition auf der Kleidung',
    Description2: 'Die Beschreibung des Musters',
    Embroidery: 'Stickerei',
    PrintingType2: 'Applikationen, bestickte Patches usw.',
    Color: 'Farbe',
    Washing: 'Waschen',
    WashingType: 'Waschart',
    WashingTypePlace: 'Steinwäsche, Enzymwäsche usw.',
    PositionPlace2: 'Welcher Ort muss gereinigt werden?',
    OtherTechnology: 'Sonstige Technologien',
    TechnologyName: 'Name der Technologie',
    Submit: 'Absenden',
    InputContent: 'Eingabeinhalt',
    edit: 'bearbeiten',
    detail: 'Detail',
    onlyPictures: 'Nur Bilder können hochgeladen werden',
    pictureSize: 'Die maximale Bildunterstützung ist 5M, Format Unterstützung: jpg,png,gif'
  },
  touristCustom: {
    SubmittedSuccessfully: 'Erfolgreich eingereicht',
    tip1: 'Klicken Sie unten, um den Kundenservice zu kontaktieren, um Ihre Anpassungsbedarfe zu kommunizieren',
    tip2: 'Oder warten Sie geduldig, bis der Kundenservice Sie kontaktiert',
    back: 'zurück',
    CustomProduct: 'Kundenspezifisches Produkt',
    AddedTime: 'Zusätzliche Zeit',
    DemandNo: 'Nachfragenummer',
    Home: 'Home'
  }
}

